import { css } from '@emotion/react';
import type { SheetProps } from '@mui/joy';
import { Sheet, styled } from '@mui/joy';

import { MAIN_BUTTON_GROUP_STICKY_CLASS_NAME } from '@/components/form-elements/MainButtonGroup';

const StyledSheet = styled(Sheet)(
  ({ theme }) => css`
    overflow: auto;
    height: 100%;
    max-height: 100svh;
    border-top-left-radius: ${theme.radius.xl};
    border-top-right-radius: ${theme.radius.xl};
  `,
);

export function MapSheet(props: SheetProps) {
  return <StyledSheet className={MAIN_BUTTON_GROUP_STICKY_CLASS_NAME} {...props} />;
}
